import { Row, Col, Card, Button, Container } from 'react-bootstrap';
import Navbars from './Navbars';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FakeStoreApi() {
  const [fetchData, setFetchdata] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      const getArray = [];

      for (let i = 1; i < 19; i++) {
        const getData = await fetch(`https://fakestoreapi.com/products/${i}`);
        const response = await getData.json();
        getArray.push(response);
      }

      setFetchdata(getArray);
    };

    fetchProducts();
  }, []);

  const handleAddToCart = (product) => {
    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
    existingCart.push(product);
    localStorage.setItem("cart", JSON.stringify(existingCart));
    navigate("/cart");
  };

  const renderStaticStars = () => {
    return (
      <div style={{ color: '#FFD700', fontSize: '1.2rem', display: 'flex', alignItems: 'center' }}>
        {"⭐".repeat(5)}
        <span style={{ color: '#333', fontSize: '0.9rem', marginLeft: '6px' }}>(157 ratings)</span>
      </div>
    );
  };

  return (
    <div>
      <Navbars />
      <Container>
        <Row className="mt-4 justify-content-center">
          {fetchData.map((fetching, index) => (
            <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
              <Card style={{ width: '18rem', height: '100%' }}>
                <Card.Img variant="top" src={fetching.image} height={200} style={{ objectFit: 'contain', padding: '1rem' }} />
                <Card.Body>
                  <Card.Title style={{ fontSize: '1rem', height: '3rem', overflow: 'hidden' }} className="shadow-sm">{fetching.title}</Card.Title>
                  <h5 className="mb-2 text-success">${fetching.price}</h5>
                  {renderStaticStars()}
                  <Card.Text style={{ fontSize: '0.85rem', marginTop: '0.5rem', color: '#555' }}>
                    {fetching.description.length > 100
                      ? fetching.description.slice(0, 100) + '...'
                      : fetching.description}
                  </Card.Text>

                  <Button variant="primary" onClick={() => handleAddToCart(fetching)}>Add to Cart</Button>
                </Card.Body>

              </Card>
            </Col>
          ))}
        </Row>

      </Container>
    </div>
  );
}
